import React from 'react';
import { observer } from 'mobx-react';

import FileItemUI from './FileItemUI';

interface Props {
  file: IUploadedFile;
  onRemove: () => void;
}

function FileItem({ file, onRemove }: Props) {
  return (
    <FileItemUI
      fileName={file.rawFile.name}
      onRemove={onRemove}
      onRetry={file.retry}
      isUploaded={file.isUploaded}
      isUploading={file.isUploading}
      isFailed={file.isFailed}
      errorCode={file.errorCode}
      percent={file.percent}
    />
  );
}

export default observer(FileItem);
